import React from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { BenefitIconWrapper, BenefitItem, ListBenefits, ModalBody, ModalFooter } from './modal-approve-purchase.styles';
import { ModalApprovePurchaseProps } from './types';
import { AllInvestmentProducts, AllOtherPeople, AllStar, StatusTimer } from '@vtbhome/juicyfront/indexIcon';
import { Modal } from '@shared/ui/modal/modal';

export const ModalApprovePurchase: React.FC<ModalApprovePurchaseProps> = ({
    isShow,
    onClose,
    handleCreateOrder,
    handleBecomeManager,
}) => {
    return (
        <Modal
            isShow={isShow}
            size='l'
            showLine={false}
            header={<Typography size='h5'>Приобретение продукта</Typography>}
            footer={
                <ModalFooter>
                    <Button type='button' buttonType='light' size='l' onClick={handleCreateOrder}>
                        Купить от своего лица
                    </Button>
                    <Button
                        type='submit'
                        buttonType='primary'
                        size='l'
                        startAdornment={<AllStar />}
                        onClick={handleBecomeManager}>
                        Стать менеджером
                    </Button>
                </ModalFooter>
            }
            onClose={onClose}>
            <ModalBody>
                <Typography size='body1_long'>
                    Обратите внимание, вы можете совершить покупку от своего лица, либо подать заявку на получение роли
                    менеджера.
                </Typography>
                <ListBenefits>
                    <BenefitItem>
                        <BenefitIconWrapper>
                            <AllOtherPeople />
                        </BenefitIconWrapper>
                        <Typography size='body1_long' color='neutral_50'>
                            Возможность осуществлять покупку не только на себя, но и на группу сотрудников одним
                            платежом.
                        </Typography>
                    </BenefitItem>
                    <BenefitItem>
                        <BenefitIconWrapper>
                            <StatusTimer />
                        </BenefitIconWrapper>
                        <Typography size='body1_long' color='neutral_50'>
                            Быстрое оформление покупки - не будет необходимости каждый раз заполнять реквизиты и прочие
                            данные. Большая часть информации подтягивается автоматически.
                        </Typography>
                    </BenefitItem>
                    <BenefitItem>
                        <BenefitIconWrapper>
                            <AllInvestmentProducts />
                        </BenefitIconWrapper>
                        <Typography size='body1_long' color='neutral_50'>
                            Возможность принимать решение о приобретении и отслеживать статус сделок сотрудников на всех
                            этапах.
                        </Typography>
                    </BenefitItem>
                </ListBenefits>
            </ModalBody>
        </Modal>
    );
};
